module.exports = __webpack_public_path__ + "img/art-work-icon10.95eacfd2.png";